import { useRef, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import SimpleReactValidator from "simple-react-validator";

import { toggleSidebar } from "../../store/actions/layout";
import { PostComplaint } from "../../store/actions/kalapost";
import { successMessage } from "../../utils/message";
import {
  correctCharacters,
  isNumber,
  isPhoneNumber,
  isPersianWithoutNumber,
} from "../../utils/persianLatter";

const Comments = () => {
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { isSidebarOpened } = useSelector((state) => state.layout);

  const [, forceUpdate] = useState();
  const [fName, setFName] = useState("");
  const [lName, setLName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [object, setObject] = useState("");
  const [description, setDescription] = useState("");

  const validator = useRef(
    new SimpleReactValidator({
      messages: {
        required: "پر کردن این فیلد الزامی میباشد",
      },
      validators: {
        phoneValid: {
          message: "شماره موبایل صحیح نیست",
          rule: (val) => {
            const numberStatus = isNumber(val);
            const charStatus = numberStatus && correctCharacters(val);
            return isPhoneNumber(charStatus);
          },
          required: true,
        },
        inputValid: {
          message: "حروف باید فارسی باشد",
          rule: (val) => isPersianWithoutNumber(val),
          required: true,
        },
        inputLength: {
          message: "باید بیشتر از دو حرف باشد",
          rule: (val) => val.length >= 2 ? true : false
        }
      },
      element: (message) => (
        <div style={{ color: "red", marginTop: ".5rem" }}>{message}</div>
      ),
    })
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e, type) => {
    switch (type) {
      case "fName":
        setFName(e.target.value);
        validator.current.showMessageFor(e.target.name);
        break;
      case "lName":
        setLName(e.target.value);
        validator.current.showMessageFor(e.target.name);
        break;
      case "phoneNumber":
        setPhoneNumber(e.target.value);
        validator.current.showMessageFor(e.target.name);
        break;
      case "comment":
        setObject(e.target.value);
        validator.current.showMessageFor(e.target.name);
        break;
      case "description":
        setDescription(e.target.value);
        validator.current.showMessageFor(e.target.name);
        break;
      default:
        break;
    }
  };
  const handleSend = async (e) => {
    e.preventDefault();
    if (validator.current.allValid()) {
      const token = await handleReCaptchaVerify();
      const res = await PostComplaint(fName, lName, object, description, phoneNumber, token);
      res.status && successMessage("پیام شما با موفقیت ارسال شد");
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) return;
    const token = await executeRecaptcha();
    return token;
  }, [executeRecaptcha]);

  return (
    <main
      className="main__comments"
      onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
    >
      <form className="kards__card kards__card-comments" onSubmit={handleSend}>
        <h2 className="comments__title">بخش نظرات | شکایات</h2>
        <div className="comments__sections">
          <h4 className="comments__lables">نام</h4>
          <input
            type="text"
            className="comments__textarea"
            name="fName"
            value={fName}
            onChange={(e) => handleChange(e, "fName")}
            required
          />
          {validator.current.message("fName", fName, "required|inputValid")}
        </div>

        <div className="comments__sections">
          <h4 className="comments__lables">نام خانوادگی</h4>
          <input
            type="text"
            className="comments__textarea"
            name="lName"
            value={lName}
            onChange={(e) => handleChange(e, "lName")}
            required
          />
          {validator.current.message("lName", lName, "required|inputValid")}
        </div>

        <div className="comments__sections">
          <h4 className="comments__lables">شماره موبایل</h4>
          <input
            type={"number"}
            name="phoneNumber"
            className="comments__textarea"
            value={phoneNumber}
            onChange={(e) => handleChange(e, "phoneNumber")}
            required
          />
          {validator.current.message("phoneNumber", phoneNumber, "required|phoneValid")}
        </div>

        <div className="comments__sections comments__sections--min-601">
          <h4 className="comments__lables">موضوع </h4>
          <select
            className="comments__selector"
            name="object"
            value={object}
            onChange={(e) => handleChange(e, "comment")}
          >
            <option hidden>
              موضوع خود را انتخاب کنید...
            </option>
            <option value="شکایت">ثبت شکایت</option>
            <option value="نظر">ثبت نظر</option>
          </select>
          {validator.current.message("object", object, "required")}
        </div>

        <div className="comments__comment-section">
          <h3 className="comments__lables">نظر </h3>
          <textarea
            type="text"
            className="comments__textarea"
            rows="6"
            name="description"
            value={description}
            onChange={(e) => handleChange(e, "description")}
            required
          />
          {validator.current.message("description", description, "required|inputLength")}
        </div>

        <button type="submit" className="btn btn--secondary">ارسال نظر</button>
      </form>

      <Link
        to="/order"
        className="main__Send-package"
      >
        <img className="main__Send-package-img" src="/img/postfix.png" alt="" />
        <h4>ارسال بسته</h4>
      </Link>
    </main>
  );
};

export default Comments;
